import {useCallback} from 'react';
import {
  isContentEmptyOrTemplate,
  validateContentLength,
} from '@/utils/help/formUtils';

export const CONTENT_ERROR_MESSAGE = '내용을 입력해 주세요.';
export const CONTENT_MIN_LENGTH_ERROR_MSG = '내용을 5자 이상 입력해 주세요.';

interface UseContentValidationProps {
  template: string;
}

export const useContentValidation = ({template}: UseContentValidationProps) => {
  const validateContent = useCallback(
    (value: string | undefined) => {
      const contentStr = String(value ?? '');

      // 1. 비어 있거나 템플릿 그대로일 때
      if (isContentEmptyOrTemplate(contentStr, template)) {
        return CONTENT_ERROR_MESSAGE;
      }

      // 2. 콘텐츠 길이 유효성 검사
      if (!validateContentLength(contentStr)) {
        return CONTENT_MIN_LENGTH_ERROR_MSG;
      }

      return true;
    },
    [template],
  );

  return {validateContent};
};
